const ThemeColorConstant = {
  secondaryColor: "#17BAB3",
  hover_background: "#0000000E",
};

export default ThemeColorConstant;
